import { render, staticRenderFns } from "./UserStampingPlaces.vue?vue&type=template&id=0260188a&scoped=true&"
import script from "./UserStampingPlaces.vue?vue&type=script&lang=js&"
export * from "./UserStampingPlaces.vue?vue&type=script&lang=js&"
import style0 from "./UserStampingPlaces.vue?vue&type=style&index=0&id=0260188a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260188a",
  null
  
)

export default component.exports